import { useState, useEffect, useRef } from "react";
import { getDomainName } from "./HelperFunctions";
import { ErrorCode, EventType, QueryParam } from "./Constants";
import { FetchError, fetchWithTimeout } from "./FetchError";
import postEvent, { createBaseLanderEvent } from "./LanderEvent";
import { Settings } from "../config";

export const useFetch = (
  url: string,
  queryConfig: Record<string, any> = {}
) => {
  const [body, setBody] = useState<any>(null);
  const [err, setErr] = useState<FetchError | null>(null);
  const eventFiredRef = useRef(false);

  const fireErrorEvent = (errorCode: string) => {
    if (eventFiredRef.current) return;
    eventFiredRef.current = true;

    const event = createBaseLanderEvent(EventType.ERROR, {});
    event.errorCode = errorCode;
    event.sToken = queryConfig[QueryParam.S_TOKEN];
    event.domain = getDomainName(queryConfig) || window.location.hostname;
    postEvent(Settings.EVENT_PUBLISH_API, event);
  };

  useEffect(() => {
    let cancelled = false;

    (async () => {
      const { response, error } = await fetchWithTimeout(url);

      if (cancelled) return;

      if (error) {
        setErr(error);
        fireErrorEvent(error.errorCode);
        return;
      }

      if (response) {
        try {
          setBody(await response.json());
        } catch {
          const parseError = new FetchError(
            "Failed to parse response JSON",
            ErrorCode.CONFIG_FETCH_INVALID_JSON
          );
          setErr(parseError);
          fireErrorEvent(parseError.errorCode);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
    // queryConfig intentionally omitted - it's stable and only used for event firing
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  return {
    body,
    err,
  };
};
